import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "type", "aria-disabled"]


const __default__ = {
  name: 'vita-button'
}

interface Props {
  width?: string
  color?: string
  disabled?: boolean
  type?: string
  buttonType?: 'button' | 'reset' | 'submit'
  btnLoading?: boolean
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    width: {},
    color: {},
    disabled: { type: Boolean, default: false },
    type: {},
    buttonType: {},
    btnLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", [__props.width, __props.color, __props.type, { 'disabled': __props.disabled, btnLoading: __props.btnLoading }]]),
    disabled: __props.disabled,
    type: __props.buttonType,
    "aria-disabled": __props.disabled
  }, [
    (!__props.btnLoading)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})